import React, { startTransition, useEffect, useState } from "react";
import { Table } from "../../Component/Table/Table";
import { download, search } from "../../assets/img";
import DateRange from "../../Component/DateRange/DateRange";
import Topbar from "../../Component/Topbar/Topbar";
import { URLS } from "../redux/api/Constants";
import { get, post, postDownload } from "../redux/api/ApiHandler";
import { useLocation, useNavigate } from "react-router-dom";
import useSearchFunction from "../../Component/searchFunction";
import moment from "moment";
import toast from "react-hot-toast";
import SelectBox1 from "../../Component/SelectBox1";
import { useForm } from "react-hook-form";
import ReportPopup from "../../Component/Report/ReportPopup";

const ReportList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [list, setList] = useState([]);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState("");
  const [selected, setSelected] = useState(null);
  const [status, setStatus] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [regionOptions, setRegionOptions] = useState([]);
  const [fromDates, setFromDates] = useState(null);
  const [toDates, setToDates] = useState(null);
  const [filterPopup, setFilterPopup] = useState(null);
  const [regionManager, setRegionManager] = useState(null);
  const [manager, setManager] = useState();
  const [statusVal, setStatusVal] = useState();
  const [firstRender, setFirstRender] = useState(false);

  //
  const [serviceEng, setServiceEng] = useState([]);
  const [selectedService, setSeletedService] = useState({
    label: "all",
    value: "",
  });
  //
  const [overallTic, setOverallTic] = useState([]);
  const [selectedTic, setSelectedTic] = useState({
    label: "all",
    value: "",
  });

  //
  const [overallCust, setOverallCust] = useState([]);
  const [selectedCust, setSelectedCust] = useState({
    label: "all",
    value: "",
  });

  //
  const [overallfault, setOverallFault] = useState([]);
  const [selectedFault, setSelectedFault] = useState({
    label: "all",
    value: "",
    fault: "",
  });

  //
  const [overallTech, setOverallTech] = useState([]);
  const [selectedTech, setSelectedTech] = useState({
    label: "all",
    value: "all",
  });

  //
  const [overallInv, setOverallInv] = useState([]);
  const [selectedInv, setSelectedInv] = useState({
    label: "all",
    value: "all",
  });

  //
  const [overallPrinter, setOverallPrinter] = useState([]);
  const [selectedPrinter, setSelectedPrinter] = useState({
    label: "all",
    value: "",
  });

  //
  const [filter, setFilter] = useState(null);

  // console.log("fromDates", fromDates);
  // console.log("manager", manager);

  const heading = location?.state?.heading;
  const indexVal = location?.state?.indexVal;

  // console.log("heading", heading);

  // console.log("region====>", region);

  const fetchOverallList = async () => {
    let res = await get(URLS.OVERALL_TICKET);
    // console.log("Overallres", res);
    if (res?.status == "success") {
      let obj = res?.ticket?.map((i) => {
        return {
          label: i?.code,
          value: i?.id,
          region_id: i?.region_id,
        };
      });

      let all = {
        label: "all",
        value: "",
      };
      setOverallTic([all, ...obj]);
    }
  };

  const fetchOverallCust = async () => {
    let res = await get(URLS.OVERALL_CUSTOMER_LIST);
    // console.log("resCust", res);
    if (res?.status == "success") {
      let obj = res?.Customer?.map((i) => {
        return {
          label: `${i?.name} - ${i?.code}`,
          value: i?.id,
          name: i?.name,
          region_id: i?.region_id,
        };
      });
      let all = {
        label: "all",
        value: "",
      };
      setOverallCust([all, ...obj]);
    }
  };

  // console.log("seleectedFault----->", selectedFault);

  const fetchFaultList = async () => {
    let res = await get(URLS.FAULT_LIST);
    // console.log("FaultListRes", res);
    if (res?.status == "success") {
      let obj = res?.fault?.map((i) => {
        return {
          label: i?.name,
          value: i?.id,
          fault: i?.name,
        };
      });
      let all = {
        label: "all",
        value: "",
        fault: "",
      };

      setOverallFault([all, ...obj]);
    }
  };

  const fetchTechnical = async () => {
    let res = await get(URLS.TECHNICAL_LIST);
    // console.log("TechnRes", res);
    if (res?.status == "success") {
      let obj = res?.technicalList?.map((i) => {
        return {
          label: `${i?.name} - ${i?.code}`,
          value: i?.id,
        };
      });

      let all = {
        label: "all",
        value: "all",
      };
      setOverallTech([all, ...obj]);
    }
  };

  const fetchInventory = async () => {
    let res = await get(URLS.INVENTORY_LIST);
    // console.log("inventoryRes", res);
    if (res?.status == "success") {
      let obj = res?.inventoryList?.map((i) => {
        return {
          label: `${i?.name} - ${i?.code}`,
          value: i?.id,
        };
      });

      // console.log("obj", obj);
      let all = {
        label: "all",
        value: "all",
      };
      setOverallInv([all, ...obj]);
    }
  };

  const fetchPrinterList = async () => {
    let res = await get(URLS.OVERALL_PRINTER_LIST);
    if (res?.status == "success") {
      let obj = res?.customerPrinter?.map((i) => {
        return {
          label: i?.sr_no,
          value: i?.sr_no,
        };
      });
      let all = {
        label: "all",
        value: "",
      };
      setOverallPrinter([all, ...obj]);
    }
  };

  useEffect(() => {
    if (location?.state?.filterType) {
      setFilterPopup(location.state.filterType);
      regionList();
    }
    switch (location?.state?.filterType) {
      case 3:
        fetchOverallList();
        break;
      case 4:
        fetchOverallCust();
        break;
      case 5:
        fetchInventory();
        break;
      case 7:
        fetchFaultList();
        fetchPrinterList();
        break;
      case 8:
        fetchTechnical();
        break;
      default:
        break;
    }
  }, [location.state]);

  // console.log("page", page);

  const deleteParams = () => {
    // console.log("deleteParams==========>");
    setFilterPopup(null);
    navigate(location.pathname, {
      replace: true,
      state: {
        heading: location?.state?.heading,
        indexVal: location?.state?.indexVal,
      },
    });
  };
  // console.log("data", data);

  const {
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      category: "",
      regionalManager: "",
      status: "",
      mobile: "",
      role: "Inventory",
      password: "",
      confirmPassword: "",
    },
  });

  const regionList = async () => {
    let res = await get(URLS.REGIONLIST);
    if (res?.status === "success" && Array.isArray(res?.roles)) {
      // 🔹 Convert API data to Select options
      const options = res?.roles.map((region) => ({
        value: region?.id,
        label: region?.name,
      }));
      // console.log("options", options);
      setRegionOptions(options);
    }
  };

  const regionManagerList = async (selected) => {
    // console.log("selected", selected);
    setSelected(selected);

    let payload = {
      region_id: selected?.value,
    };
    let res = await post(URLS.REGIONAL_MANAGERS, payload);
    // console.log("resManager", res);

    if (selected && filterPopup == 2) {
      serviceEngList(res);
    }

    if (res) {
      setValue("regionalManager", res[0]?.name ? res[0]?.name : "");
      setRegionManager(res[0]?.id);
      setManager(res[0]);
    }
  };

  const statusOptions = [
    { value: 1, label: "New Ticket" },
    { value: 2, label: "Pending" },
    { value: 3, label: "Work Completed" },
    { value: 4, label: "Ticket Closed" },
  ];

  // console.log("firstRender", firstRender);

  // console.log("selectedtech", selectedTech, "selecetdinv", selectedInv);

  // console.log("faultType", selectedFault);

  const regionReport = async (
    search,
    selected,
    fromDate,
    toDate,
    status,
    selectedService,
    selectedTic,
    selectedCust,
    selectedFault,
    selectedInv,
    selectedTech,
    selectedPrinter,
    trigger,
  ) => {
    // console.log("selceted", selected);
    setFirstRender(true);
    setStatus(status);
    setSelected(selected);
    setFromDates(fromDate);
    setToDates(toDate);
    console.group("FindExcepayload");
    console.log("trigger------>", trigger);
    console.groupEnd();
    if (trigger) {
      setFilter(true);
    }

    // console.log("calling============>");
    let count = 1;

    if (filterPopup) {
      if (!fromDate) {
        toast.error("Enter From Date");
        count = count + 1;
        return;
      }
      if (!toDate) {
        toast.error("Enter To Date");
        count = count + 1;
        return;
      }
    }

    const formData = new FormData();

    formData.append("search", search?.toLowerCase() ?? "");
    formData.append("region_id", selected?.value ?? "");

    formData.append(
      "regional_manager_id",
      !trigger ? (selected?.value ? (regionManager ?? "") : "") : "",
    );

    formData.append(
      "from_date",
      fromDate ? moment(fromDate).format("YYYY-MM-DD HH:mm:ss") : "",
    );

    formData.append(
      "to_date",
      toDate ? moment(toDate).format("YYYY-MM-DD HH:mm:ss") : "",
    );

    formData.append("status", status?.value ?? "");
    formData.append("page", page ?? "");

    formData.append("service_engineer_id", selectedService?.value ?? "");

    formData.append("ticket_id", selectedTic?.value ?? "");

    formData.append("customer_id", selectedCust?.value ?? "");

    if (selectedFault?.label == "all" && indexVal == 7) {
      formData.append("fault_search", "fault");
    } else {
      formData.append("fault_type", selectedFault?.fault ?? "");
    }

    formData.append("sr_no", selectedPrinter?.value ?? "");

    const map = {
      5: { key: "inv", statuses: [4, 9, 10], selected: selectedInv },
      8: { key: "tech", statuses: [5, 6, 13], selected: selectedTech },
    };

    const config = map[indexVal];

    if (config?.selected?.value) {
      if (config.selected.value !== "all") {
        formData.append("assigned_id", config.selected.value);
      }

      config.statuses.forEach((status, index) => {
        formData.append(`current_status[${index}]`, status);
      });
    }

    console.group("sendingPayload");
    // console.log("indexVal", indexVal);
    for (let pair of formData.entries()) {
      console.log(pair[0], pair[1]);
    }
    console.groupEnd();

    // return;

    if (count == 1 && firstRender) {
      let res = await post(URLS.REGION_REPORT, formData);
      if (res?.status === "success") {
        if (firstRender) {
          deleteParams();
        }

        let newObj = res?.lists?.map((i) => ({
          ...i,
          customer_id: i?.customer?.id,
          page: res?.pagination_meta?.current_page,
          ticket_details_data: i?.ticket_details,
          assigned_user: i?.assigned_user,
          customer_number: i?.customer?.mobile,
        }));

        setList(newObj);
        setPage(res?.pagination_meta?.current_page);
        setPagination(res?.pagination_meta);
      }
    }
  };

  const debounceval = useSearchFunction(searchValue);

  useEffect(() => {
    regionReport(
      debounceval,
      selected,
      fromDates,
      toDates,
      status,
      selectedService,
      selectedTic,
      selectedCust,
      selectedFault,
      selectedInv,
      selectedTech,
      selectedPrinter,
    );
  }, [debounceval, page]);

  // console.log("poppp", location?.state?.openPopup);

  // console.log("list", list);

  // console.log("selected---inv", selectedInv);
  // console.log("selected---tech", selectedTech);

  const columns = React.useMemo(() => {
    const dynamicColumn =
      indexVal == 5
        ? [
            {
              Header: "Inventory",
              accessor: "assigned_user",
              Cell: ({ value }) => (
                <div>
                  <p className="text-start text-nowrap ">{value?.name}</p>
                  <p className=" text-start text-nowrap">{value?.id}</p>
                </div>
              ),
            },
          ]
        : indexVal == 8
          ? [
              {
                Header: "Technical",
                accessor: "assigned_user",
                Cell: ({ value }) => (
                  <div>
                    <p className=" text-start text-nowrap">{value?.name}</p>
                    <p className=" text-start text-nowrap">{value?.id}</p>
                  </div>
                ),
              },
            ]
          : [];

    return [
      {
        Header: "S.No",
        accessor: "page",
        Cell: ({ value, row }) => {
          return <p>{(value - 1) * 10 + row.index + 1}</p>;
        },
      },

      {
        Header: "Ticket ID ",
        accessor: "code",
        Cell: ({ value, row }) => {
          return <p className="text-start text-nowrap ">{value}</p>;
        },
      },
      ...dynamicColumn,
      {
        Header: "Region",
        accessor: "region",
        Cell: ({ value, row }) => {
          return <p className="text-start text-nowrap ">{value ?? "-"}</p>;
        },
      },
      {
        Header: "Service engineer",
        accessor: "service_engineer",
        Cell: ({ value, row }) => {
          return <p className="text-start text-nowrap ">{value ?? "-"}</p>;
        },
      },
      // {
      //   Header: "Regional manager",
      //   accessor: "regional_manager",
      //   Cell: ({ value, row }) => {
      //     return <p className="text-nowrap ">{value ?? "-"}</p>;
      //   },
      // },

      // {
      //   Header: "Customer ID",
      //   accessor: "customer_id",
      //   Cell: ({ value, row }) => {
      //     return <p className="text-nowrap ">{value ?? "-"}</p>;
      //   },
      // },
      {
        Header: "Customer Name",
        accessor: "customer",
        Cell: ({ value, row }) => {
          return (
            <p className="text-start text-nowrap ">{value?.name ?? "-"}</p>
          );
        },
      },
      // {
      //   Header: "Customer Number",
      //   accessor: "customer_number",
      //   Cell: ({ value, row }) => {
      //     return <p className="text-nowrap ">{value ?? "-"}</p>;
      //   },
      // },
      {
        Header: "Created Date",
        accessor: "created_at",
        Cell: ({ value, row }) => {
          return (
            <p className="text-start text-nowrap ">
              {moment(value).format("DD-MM-YYYY")}
            </p>
          );
        },
      },

      {
        Header: "Created By",
        accessor: "created_by",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value?.name ?? "-"} - RM</p>;
        },
      },

      {
        Header: "Printer S.No",
        accessor: "customer_printer",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value?.sr_no ?? "-"}</p>;
        },
      },
      // {
      //   Header: "Follow Up",
      //   accessor: "",
      //   Cell: ({ value, row }) => {
      //     return (
      //       <p className="text-nowrap ">
      //         Service Engineer → <br />
      //         <span> Technical→ </span> <br />
      //         <span style={{ color: "#323691" }}> Inventory</span>
      //       </p>
      //     );
      //   },
      // },
      {
        Header: "Follow Up",
        accessor: "ticket_details_data",
        Cell: ({ value, row }) => {
          // Step 1: Prepare flow (same as your stepper)
          const flowArr =
            value
              ?.filter((item) => item?.moved_to == null)
              ?.sort((a, b) => a.id - b.id) || [];

          const flow = flowArr.slice(1); // after Service Engineer

          const roleMap = {
            1: "Technical",
            2: "Inventory",
            3: "Next Visit",
            4: "Senior Support",
            5: "Work Completed",
          };

          const WorkCompleted = flowArr.some(
            (item) => item?.support_needed === 5,
          );

          // Step 2: Base flow
          const flowText = ["Create", "Service Engineer"];

          // Step 3: Add follow-up flow
          if (flow.length > 0) {
            flow.forEach((item) => {
              const roleName = roleMap[item?.support_needed];
              if (roleName) flowText.push(roleName);
            });
          }

          // Step 4: Direct Work Completed (NO FOLLOW-UP)
          if (flow.length === 0 && WorkCompleted) {
            flowText.push("Work Completed");
          }

          // Step 5: Ticket Closed
          if (row.original?.status === 4) {
            flowText.push("Ticket Closed");
          }

          return (
            <p className="text-start text-wrap" style={{ width: "300px" }}>
              {flowText.map((item, index) => (
                <React.Fragment key={index}>
                  <span
                    className={`flow-item ${
                      item === "Ticket Closed" ? "text-success" : ""
                    }`}
                  >
                    {item}
                  </span>
                  {index < flowText.length - 1 && (
                    <span className="flow-arrow"> → </span>
                  )}
                </React.Fragment>
              ))}
            </p>
          );
        },
      },

      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value, row }) => {
          return (
            <div className="d-flex ac-js">
              <button
                className="Yet_To_Start f1 fs-xs-12 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-15 fs-xxl-16"
                style={{
                  backgroundColor:
                    value == 1
                      ? "#F57C00" // darker orange
                      : value == 2
                        ? "#E53935" // darker red
                        : value == 3
                          ? "#1E88E5" // darker blue
                          : "#43A047", // darker green
                }}
              >
                {value == 1
                  ? "New Ticket"
                  : value == 2
                    ? "Pending"
                    : value == 3
                      ? "Work Completed"
                      : value == 4
                        ? "Ticket Closed"
                        : ""}
              </button>
            </div>
          );
        },
      },
      {
        Header: "Problem Report",
        accessor: "customer_issue",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap col-md-3">{value ?? "-"}</p>;
        },
      },
      {
        Header: "Fault Type",
        accessor: "ticket_details",
        Cell: ({ value, row }) => {
          return <p className="text-start ">{value?.[0]?.fault_type ?? "-"}</p>;
        },
      },
      {
        Header: "Closed Date",
        accessor: "closed_at",
        Cell: ({ value, row }) => {
          return (
            <p className="text-nowrap ">
              {value ? moment(value).format("DD-MM-YYYY") : "-"}
            </p>
          );
        },
      },
      {
        Header: "Closed By",
        accessor: "closed_by",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value?.name ?? "-"}</p>;
        },
      },
    ];
  }, [indexVal]);

  // console.group("denote");
  // console.log("selected", selected);
  // console.log("status", status);
  // console.groupEnd();

  const serviceEngList = async (res) => {
    // console.log("res===>", res);

    let payload = {
      regional_manager_id: res[0]?.id,
    };

    let response = await post(URLS.SERVICE_ENGINEER_LIST, payload);
    // console.log("serviceRes", response);
    if (response?.status == "success") {
      let obj = response?.serviceEngineer?.map((i) => {
        return {
          label: `${i?.name} - ${i?.code}`,
          value: i?.id,
          code: i?.code,
        };
      });

      let all = {
        label: "all",
        value: "",
      };

      setServiceEng([all, ...obj]);
    }
  };

  const handleDownload = async () => {
    try {
      const formData = new FormData();

      formData.append("download", true);
      formData.append("search", debounceval?.toLowerCase() ?? "");
      formData.append("region_id", selected?.value ?? "");

      formData.append(
        "regional_manager_id",
        !filter ? (selected?.value ? (regionManager ?? "") : "") : "",
      );

      formData.append(
        "from_date",
        fromDates ? moment(fromDates).format("YYYY-MM-DD HH:mm:ss") : "",
      );

      formData.append(
        "to_date",
        toDates ? moment(toDates).format("YYYY-MM-DD HH:mm:ss") : "",
      );
      // tab_type: !filter
      //   ? selectedInv?.value
      //     ? "inventory"
      //     : selectedTech?.value
      //     ? "technical"
      //     : "regional_manager"
      //   : "regional_manager",

      if (indexVal == 5) {
        formData.append("tab_type", "inventory");
      }

      if (indexVal == 8) {
        formData.append("tab_type", "technical");
      }

      formData.append("status", status?.value ?? "");
      formData.append("service_engineer_id", selectedService?.value ?? "");
      formData.append("ticket_id", selectedTic?.value ?? "");
      formData.append("customer_id", selectedCust?.value ?? "");
      if (selectedFault?.label === "all" && indexVal == 7) {
        formData.append("fault_search", "fault");
      } else {
        formData.append("fault_type", selectedFault?.fault ?? "");
      }

      const map = {
        5: { statuses: [4, 9, 10], selected: selectedInv },
        8: { statuses: [5, 6, 13], selected: selectedTech },
      };

      const config = map[indexVal];

      if (config?.selected?.value) {
        // assigned_id only when not "all"
        if (config.selected.value !== "all") {
          formData.append("assigned_id", config.selected.value);
        }

        // 🔥 ALWAYS append current_status
        config.statuses.forEach((status, index) => {
          formData.append(`current_status[${index}]`, status);
        });
      }

      formData.append("sr_no", selectedPrinter?.value ?? "");

      console.group("DOWNLOAD PAYLOAD");
      for (let pair of formData.entries()) {
        console.log(pair[0], pair[1]);
      }
      console.groupEnd();

      // return;
      const response = await postDownload(URLS.REGION_REPORT, formData);

      const blob = new Blob([response.data], {
        type: "text/csv;charset=utf-8;",
      });

      const filename = "Region_Report.csv";
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");

      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      // console.error("Download Error:", err);
      toast.error("Excel download failed");
    }
  };

  // console.log("reg", regionManager);
  // console.log("filter", filter);

  const handleSelect = (val) => {
    if (!val || !val?.value) {
      setServiceEng([]);
    }
    regionReport(
      searchValue,
      val,
      fromDates,
      toDates,
      status,
      selectedService,
      selectedTic,
      selectedCust,
      selectedFault,
      selectedInv,
      selectedTech,
      "region",
    );
  };

  const handleChoose = (val, ind) => {
    let inv = selectedInv;
    let tech = selectedTech;
    let tic = selectedTic;
    let cust = selectedCust;
    let fault = selectedFault;
    let service = selectedService;

    if (ind == 2) {
      service = val;
      setSeletedService(val);
    }

    if (ind === 3) {
      tic = val;
      setSelectedTic(val);
    }

    if (ind === 4) {
      cust = val;
      setSelectedCust(val);
    }

    if (ind === 5) {
      inv = val;
      setSelectedInv(val);
    }

    if (ind === 7) {
      fault = val;
      setSelectedFault(val);
    }

    if (ind === 8) {
      tech = val;
      setSelectedTech(val);
    }

    regionReport(
      searchValue,
      selected,
      fromDates,
      toDates,
      status,
      service,
      tic,
      cust,
      fault,
      inv,
      tech,
      selectedPrinter,
      "assigned",
    );
  };

  const handleFetchService = async (val) => {
    // console.log("val---->", val);
    if (!val || val?.value == "") {
      return;
    }

    let payload = {
      region_id: val?.value,
    };

    let res = await post(URLS.OVERALL_SERVICE_LIST, payload);
    if (res?.status == "success") {
      let obj = res?.data?.map((i) => {
        return {
          label: i?.name,
          value: i?.id,
        };
      });
      let all = {
        label: "all",
        value: "",
      };

      setServiceEng([all, ...obj]);
    }
  };

  const handlePrinterSelect = (val) => {
    let printer = selectedPrinter;
    // console.log("printerVal------>", val);
    if (val) {
      printer = val;
      setSelectedPrinter(val);
    }

    regionReport(
      searchValue,
      selected,
      fromDates,
      toDates,
      status,
      selectedService,
      selectedTic,
      selectedCust,
      selectedFault,
      selectedInv,
      selectedTech,
      printer,
    );
  };

  return (
    <>
      <Topbar header={"Report"} back={true} />
      <div className="container_fluit1">
        <div className="d-flex ac-js">
          <h3 className="f3 fs-sm-14 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 mb-4">
            {heading} Report
          </h3>
        </div>
        <div className="d-flex ac-jb w-100">
          <h4 className="f2 fs-sm-13 fs-md-15 fs-lg-16 fs-xl-17 fs-xxl-18">
            Total Ticket : <span className="f3"> {pagination?.total}</span>
          </h4>
          <div className=" w-80 d-flex ac-je gap-3">
            <DateRange
              fromDate={fromDates}
              setFromDate={(val) =>
                regionReport(
                  searchValue,
                  selected,
                  val,
                  toDates,
                  status,
                  selectedService,
                  selectedTic,
                  selectedCust,
                  selectedFault,
                  selectedInv,
                  selectedTech,
                  "fromDate",
                )
              }
              toDate={toDates}
              setToDate={(val) =>
                regionReport(
                  searchValue,
                  selected,
                  fromDates,
                  val,
                  status,
                  selectedService,
                  selectedTic,
                  selectedCust,
                  selectedFault,
                  selectedInv,
                  selectedTech,
                  "toDate",
                )
              }
            />
            {list.length > 0 && (
              <div
                onClick={() => handleDownload()}
                className="d-flex ac-jc import gap-2 pointer"
              >
                <p className="f3 fs-sm-13 fs-md-15 fs-lg-16 fs-xl-17 fs-xxl-18">
                  Download
                </p>
                <img src={download} height={18} />
              </div>
            )}
          </div>
        </div>

        <div className="d-flex ac-jb">
          {![1, 6].includes(indexVal) && (
            <div className="col-md-4 ">
              <p className="f2 fs-sm-13 fs-md-15 fs-lg-16 fs-xl-17 fs-xxl-18">
                {indexVal == 2
                  ? "Select service engineer"
                  : indexVal == 3
                    ? "Select Ticket"
                    : indexVal == 5
                      ? "Select Inventory"
                      : indexVal == 7
                        ? "Select Fault type"
                        : "Select Technical"}
              </p>
              <SelectBox1
                placeholder={
                  indexVal == 2
                    ? "Select service engineer"
                    : indexVal == 3
                      ? "Select Ticket"
                      : indexVal == 5
                        ? "Select Inventory"
                        : indexVal == 7
                          ? "Select Fault type"
                          : "Select Technical"
                }
                selected={
                  indexVal == 2
                    ? selectedService
                    : indexVal == 3
                      ? selectedTic
                      : indexVal == 4
                        ? selectedCust
                        : indexVal == 5
                          ? selectedInv
                          : indexVal == 7
                            ? selectedFault
                            : selectedTech
                }
                options={
                  indexVal == 2
                    ? serviceEng
                    : indexVal == 3
                      ? overallTic
                      : indexVal == 4
                        ? overallCust
                        : indexVal == 5
                          ? overallInv
                          : indexVal == 7
                            ? overallfault
                            : overallTech
                }
                setSelected={(val) => handleChoose(val, indexVal)}
                isClearable={false}
              />
            </div>
          )}

          {indexVal == 7 && (
            <div className="col-md-4">
              <p className="f2 fs-sm-13 fs-md-15 fs-lg-16 fs-xl-17 fs-xxl-18">
                Select Printer
              </p>
              <SelectBox1
                options={overallPrinter}
                selected={selectedPrinter}
                placeholder={"Select Printer"}
                setSelected={(val) => handlePrinterSelect(val)}
                isClearable={false}
              />
            </div>
          )}
        </div>

        <div className="d-flex ac-jb">
          {![5, 8].includes(indexVal) && (
            <div className="col-md-4">
              <SelectBox1
                placeholder={"Select Ticket Status"}
                options={statusOptions}
                selected={status}
                setSelected={(val) => {
                  regionReport(
                    searchValue,
                    selected,
                    fromDates,
                    toDates,
                    val,
                    selectedService,
                    selectedTic,
                    selectedCust,
                    selectedFault,
                    selectedInv,
                    selectedTech,
                    "status",
                  );
                }}
              />
            </div>
          )}
          <div className="col-md-4">
            <SelectBox1
              placeholder={"Select Region"}
              options={regionOptions}
              selected={selected}
              setSelected={(val) => {
                handleSelect(val);
                setSeletedService({
                  label: "all",
                  value: "",
                });
                handleFetchService(val);
              }}
            />
          </div>

          <div className="search-input col-md-3 my-4 tooltip-wrapper">
            <div className="d-flex ac-jb">
              <input
                value={searchValue}
                onChange={(e) => {
                  startTransition(() => {
                    setSearchValue(e.target.value);
                  });
                }}
                type="text"
                placeholder="Search"
                className="search-field f1 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17"
              />
              <img src={search} className="search" />
            </div>

            {/* Tooltip */}
            <div className="search-tooltip">
              Search with Customer Name, Regional Manager name, Region name,
              Ticket ID, Customer mobile, Service Engineer, Printer ID
            </div>
          </div>
        </div>
        <Table
          columns={columns}
          setPageno={setPage}
          pagecount={pagination}
          data={list ?? []}
          show={true}
        />
        {filterPopup && (
          <ReportPopup
            filterPopup={filterPopup}
            setFilterPopup={setFilterPopup}
            regionReport={regionReport}
            regionManagerList={regionManagerList}
            deleteParams={deleteParams}
            statusOptions={statusOptions}
            searchValue={searchValue}
            regionOptions={regionOptions}
            selected={selected}
            setSelected={setSelected}
            regionManager={manager}
            statusVal={statusVal}
            setStatusVal={setStatusVal}
            //
            serviceEng={serviceEng}
            selectedService={selectedService}
            setSeletedService={setSeletedService}
            //
            overallTic={overallTic}
            selectedTic={selectedTic}
            setSelectedTic={setSelectedTic}
            //
            overallCust={overallCust}
            selectedCust={selectedCust}
            setSelectedCust={setSelectedCust}
            //
            overallfault={overallfault}
            selectedFault={selectedFault}
            setSelectedFault={setSelectedFault}
            //
            overallTech={overallTech}
            selectedTech={selectedTech}
            setSelectedTech={setSelectedTech}
            //
            overallInv={overallInv}
            selectedInv={selectedInv}
            setSelectedInv={setSelectedInv}
            //
            fromDates={fromDates}
            setFromDates={setFromDates}
            toDates={toDates}
            setToDates={setToDates}
            //
            overallPrinter={overallPrinter}
            selectedPrinter={selectedPrinter}
            setSelectedPrinter={setSelectedPrinter}
          />
        )}
      </div>
    </>
  );
};

export default ReportList;
